// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rocket';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m16.438 1.61-1.53.17a5.313 5.313 0 0 0-3.169 1.523L4.792 10.25l3.004 3.005 6.948-6.947a5.308 5.308 0 0 0 1.524-3.17z' />
    <path d='m4.793 10.25-2.566-.855a.53.53 0 0 1-.208-.88l.165-.164a4.25 4.25 0 0 1 4.349-1.027l.889.296zm3.003 3.005.855 2.565a.53.53 0 0 0 .88.208l.165-.164a4.25 4.25 0 0 0 1.026-4.35l-.295-.885zm-1.786.376a1.589 1.589 0 0 1-.467 1.127c-.622.622-3.754 1.502-3.754 1.502s.88-3.134 1.503-3.754a1.591 1.591 0 0 1 1.022-.464' />
  </g>
);

export const viewBox = '0 0 18 18';
